import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { SidebarItem } from '@/shared/ui/components/SidebarItem';
import { SvgSelector } from '@/shared/lib/assets/svg-selector';
import s from './Sidebar.module.scss';
export const Sidebar = () => {
    const navigate = useNavigate();
    return (_jsxs("div", { className: s.sidebar, children: [_jsx(SidebarItem, { color: "blue", onClick: () => navigate('/'), children: _jsx(SvgSelector, { id: "delab" }) }), _jsx(SidebarItem, { onClick: () => navigate('/'), children: _jsx(SvgSelector, { id: "home" }) }), _jsx(SidebarItem, { onClick: () => navigate('/apps'), children: _jsx(SvgSelector, { id: "layers" }) })] }));
};
